import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

/// <reference types="@angular/localize" />

loadMatomoTagManager(environment.matomoConfig.tagManagerContainerUrl);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err));

/** Matomo Tag Manager – the container URL depends on the build configuration (see environments/*.ts). */
function loadMatomoTagManager(containerUrl?: string) {
  if (!containerUrl) return;
  const w = window as Window & { _mtm?: unknown[] };
  const _mtm = (w._mtm = w._mtm || []);
  _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
  const script = document.createElement('script');
  script.async = true;
  script.src = containerUrl;
  document.head.appendChild(script);
}
